export default __webpack_public_path__ + "static/media/Sunglasses.6c5f1538.png";